import { useContext } from 'react';
import type React from 'react';

import { useCanEdit } from '@ragu-components/ord-components';
import { usePermissions } from 'react-admin';
import { Navigate } from 'react-router-dom';

import { personalEndpointContext } from '../context/personalEndpointContext';

import type { RaRecord } from 'react-admin';

interface FlowchartReadonlyRedirectProps {
  resource: string;
  record: RaRecord | undefined;
}

/**
 * Route-level permission checks match label-scoped edit permissions optimistically,
 * so record-level readonly users can reach the edit route. Once the record is loaded,
 * evaluate the real record-level permission and send them to the readonly show route.
 * Mirrors RedirectReadonlyToShow in OrdEdit. Personal endpoints are always editable.
 */
const FlowchartReadonlyRedirect = ({ resource, record }: FlowchartReadonlyRedirectProps): React.ReactElement | null => {
  const isPersonal = useContext(personalEndpointContext);
  const { isPending } = usePermissions();
  const canEdit = useCanEdit();

  if (isPersonal || isPending || record === undefined) return null;
  if (canEdit(resource, record)) return null;

  return <Navigate to={`/${resource}/${record.id}/show`} replace />;
};

export default FlowchartReadonlyRedirect;
